import React from 'react';
import styled from 'styled-components';
import { Clear } from '@material-ui/icons';

//TODO: Move this into a utility file
const whenTruthyProp = (propName, styles) => props => (!!props[propName] ? styles : '');
const whenFalsyProp = (propName, styles) => props => (!props[propName] ? styles : '');

const primaryColors = `
    color: #fff;
    background-color: #297dfd;
`;

const secondaryColors = `
    border: 1px solid #b3b3b3;
    background-color: #e9e9e9;  
    color: #595959; 
`;

const primaryIconStyle = `
    background-color: #ffffff;
    color: blue;
`;

const secondaryIconStyle = `
    border: 1px solid #b3b3b3;
    background-color: #ffffff;
    color: #595959;
`;

const RemovePillContainer = styled.span`
    display: inline-block;
    position: absolute;
    right: 7px;
    top: 4px;

    border-radius: 50%;
    height: 13px;
    width: 13px;
    padding: 1px;
    cursor: pointer;

    ${({ secondary }) => (secondary ? secondaryIconStyle : primaryIconStyle)} ${whenTruthyProp(
        'disabled',
        `
        background-color: #d9d9d9;
        color : #999;
        cursor: default;
    `
    )};

    & svg {
        font-size: 13px;
        ${whenTruthyProp('disabled', 'cursor: default')};
    }
`;

const Pill = ({ className, children, secondary, disabled, removePill }) => {
    return (
        <span className={className} title={children}>
            {children}
            {removePill && (
                <RemovePillContainer secondary={secondary} disabled={disabled} onClick={removePill}>
                    <Clear />
                </RemovePillContainer>
            )}
        </span>
    );
};

export default styled(Pill)`
    position: relative;
    display: inline-block;
    border-radius: 20px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 13px;
    cursor: default;
    padding: 5px 10px;

    ${whenFalsyProp('fullWidth', 'max-width: 80px;')}
    ${whenTruthyProp('removePill', 'padding-right: 30px;')}
    ${({ secondary }) => (secondary ? secondaryColors : primaryColors)}
    ${whenTruthyProp(
        'disabled',
        `
        background-color: #d9d9d9;
        color: #999;
    `
    )};
`;
